// // src/components/TransactionsTable.jsx
// import { useState, useEffect } from "react";
// import axios from "axios";
// import { Download, FileText, RefreshCw } from "lucide-react";

// export default function TransactionsTable() {
//   const [transactions, setTransactions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");

//   const fetchTransactions = async () => {
//     try {
//       setLoading(true);
//       // Replace with your real API endpoint when ready
//       const res = await axios.get("http://127.0.0.1:8000/api/transactions/");
//       setTransactions(res.data || []);
//     } catch (error) {
//       console.error("Failed to fetch transactions:", error);
//       // Use sample data on error (for development)
//       setTransactions(sampleTransactions);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchTransactions();
//   }, []);

//   // Sample data matching your screenshot
//   const sampleTransactions = [
//     {
//       order_id: "ORD-145",
//       organization: "Career MentorZ",
//       cards: 50,
//       amount: 2450.00,
//       method: "UPI",
//       status: "Active",
//       date: "2025-03-12",
//       receipt: true,
//     },
//     {
//       order_id: "ORD-132",
//       organization: "GoodUX Pvt Ltd",
//       cards: 80,
//       amount: 3920.00,
//       method: "CASH",
//       status: "Active",
//       date: "2025-02-28",
//       receipt: false,
//     },
//     {
//       order_id: "ORD-119",
//       organization: "TechNova Solutions",
//       cards: 30,
//       amount: 1470.00,
//       method: "CARD",
//       status: "Expired",
//       date: "2025-01-15",
//       receipt: true,
//     },
//     {
//       order_id: "ORD-108",
//       organization: "Career MentorZ",
//       cards: 40,
//       amount: 1960.00,
//       method: "UPI",
//       status: "Active",
//       date: "2024-12-05",
//       receipt: false,
//     },
//     {
//       order_id: "ORD-97",
//       organization: "PixelCraft Studio",
//       cards: 25,
//       amount: 1225.00,
//       method: "CASH",
//       status: "Expired",
//       date: "2024-10-20",
//       receipt: true,
//     },
//     {
//       order_id: "ORD-85",
//       organization: "InnoWave Tech",
//       cards: 60,
//       amount: 2940.00,
//       method: "UPI",
//       status: "Active",
//       date: "2024-09-10",
//       receipt: false,
//     },
//     {
//       order_id: "ORD-72",
//       organization: "GoodUX Pvt Ltd",
//       cards: 35,
//       amount: 1715.00,
//       method: "CARD",
//       status: "Expired",
//       date: "2024-07-18",
//       receipt: true,
//     },
//     {
//       order_id: "ORD-64",
//       organization: "Career MentorZ",
//       cards: 70,
//       amount: 3430.00,
//       method: "CASH",
//       status: "Active",
//       date: "2024-05-22",
//       receipt: false,
//     },
//   ];

//   const dataToShow = transactions.length > 0 ? transactions : sampleTransactions;

//   // Simple client-side search
//   const filteredTransactions = dataToShow.filter(
//     (t) =>
//       t.order_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       t.organization?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       t.amount?.toString().includes(searchTerm)
//   );

//   const getStatusStyle = (status) => {
//     if (status === "Active") {
//       return "bg-green-950/60 text-gain-green border-green-800/50";
//     }
//     if (status === "Expired") {
//       return "bg-red-950/60 text-loss-red border-red-800/50";
//     }
//     return "bg-gray-800 text-gray-400 border-gray-700";
//   };

//   return (
//     <div className="m-6 rounded-2xl shadow-2xl overflow-hidden border bg-card-bg border-card-border dark:bg-card-bg dark:border-card-border">
//       {/* Header */}
//       <div className="px-6 md:px-8 py-6 border-b flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 bg-secondary-bg border-card-border dark:bg-secondary-bg dark:border-card-border">
//         <div>
//           <h3 className="text-2xl font-bold text-primary-text dark:text-primary-text">
//             Payment Transactions
//           </h3>
//           <p className="mt-1 text-sm text-secondary-text dark:text-secondary-text">
//             {filteredTransactions.length} transactions found
//           </p>
//         </div>

//         <div className="flex items-center gap-4 w-full sm:w-auto">
//           {/* Search */}
//           <div className="relative flex-1 sm:flex-none min-w-[240px]">
//             <input
//               type="text"
//               placeholder="Search order, org, amount..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="
//                 w-full pl-10 pr-4 py-2.5 rounded-xl 
//                 bg-secondary-bg border border-card-border 
//                 text-primary-text placeholder:text-secondary-text
//                 focus:border-accent-orange-500 focus:ring-2 focus:ring-accent-orange-500/20
//               "
//             />
//             <svg
//               className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-secondary-text"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//             </svg>
//           </div>

//           {/* Refresh */}
//           <button
//             onClick={fetchTransactions}
//             disabled={loading}
//             className="
//               flex items-center gap-2 px-5 py-2.5 
//               bg-accent-orange-900/30 hover:bg-accent-orange-900/50 
//               text-accent-orange-400 hover:text-accent-orange-300 
//               rounded-xl border border-accent-orange-800/50 transition-all
//               disabled:opacity-50
//             "
//           >
//             <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />
//             Refresh
//           </button>

//           {/* Export CSV */}
//           <button
//             className="
//               flex items-center gap-2 px-5 py-2.5 
//               bg-accent-orange-600 hover:bg-accent-orange-700 
//               text-white rounded-xl shadow-md transition-all
//             "
//           >
//             <Download className="w-4 h-4" />
//             Export CSV
//           </button>
//         </div>
//       </div>

//       {/* Table */}
//       <div className="overflow-x-auto">
//         <table className="w-full text-sm min-w-[1100px]">
//           <thead className="bg-secondary-bg border-b border-card-border dark:bg-secondary-bg dark:border-card-border">
//             <tr>
//               <th className="text-left py-4 px-8 font-semibold text-secondary-text">Order ID</th>
//               <th className="text-left py-4 px-8 font-semibold text-secondary-text">Organization</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text">Cards</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text">Amount</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text">Method</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text">Status</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text">Date</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text">Receipt</th>
//             </tr>
//           </thead>

//           <tbody className="divide-y divide-card-border dark:divide-card-border">
//             {loading ? (
//               <tr>
//                 <td colSpan={8} className="py-16 text-center text-secondary-text">
//                   Loading transactions...
//                 </td>
//               </tr>
//             ) : filteredTransactions.length === 0 ? (
//               <tr>
//                 <td colSpan={8} className="py-16 text-center text-secondary-text">
//                   No transactions found
//                 </td>
//               </tr>
//             ) : (
//               filteredTransactions.map((tx) => (
//                 <tr
//                   key={tx.order_id}
//                   className="hover:bg-accent-orange-950/20 transition-colors dark:hover:bg-accent-orange-950/30"
//                 >
//                   <td className="py-5 px-8 font-medium text-primary-text">{tx.order_id}</td>
//                   <td className="py-5 px-8 text-primary-text">{tx.organization}</td>
//                   <td className="py-5 px-6 text-primary-text">{tx.cards}</td>
//                   <td className="py-5 px-6 text-primary-text">
//                     ₹{tx.amount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
//                   </td>
//                   <td className="py-5 px-6 text-primary-text">{tx.method}</td>
//                   <td className="py-5 px-6">
//                     <span
//                       className={`
//                         px-3 py-1 rounded-full text-xs font-medium border
//                         ${getStatusStyle(tx.status)}
//                       `}
//                     >
//                       {tx.status}
//                     </span>
//                   </td>
//                   <td className="py-5 px-6 text-primary-text">{tx.date}</td>
//                   <td className="py-5 px-6">
//                     {tx.receipt ? (
//                       <button className="text-accent-orange-400 hover:text-accent-orange-300 transition">
//                         <FileText className="w-5 h-5" />
//                       </button>
//                     ) : (
//                       <span className="text-secondary-text">N/A</span>
//                     )}
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// src/components/TransactionsTable.jsx
import { useState, useEffect } from "react";
import axios from "axios";
import { Download, FileText, RefreshCw, X } from "lucide-react";

export default function TransactionsTable() {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedReceipt, setSelectedReceipt] = useState(null); // For modal

  const fetchTransactions = async () => {
    try {
      setLoading(true);
      const res = await axios.get("http://127.0.0.1:8000/api/transactions/");
      setTransactions(res.data || []);
    } catch (error) {
      console.error("Failed to fetch transactions:", error);
      setTransactions(sampleTransactions); // Fallback to sample data
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  // Sample data
  const sampleTransactions = [
    {
      order_id: "ORD-145",
      organization: "Career MentorZ",
      cards: 50,
      amount: 2450.00,
      method: "UPI",
      status: "Active",
      date: "2025-03-12",
      receipt: true,
    },
    {
      order_id: "ORD-132",
      organization: "GoodUX Pvt Ltd",
      cards: 80,
      amount: 3920.00,
      method: "CASH",
      status: "Active",
      date: "2025-02-28",
      receipt: false,
    },
    // ... (keep all your other sample data)
    {
      order_id: "ORD-119",
      organization: "TechNova Solutions",
      cards: 30,
      amount: 1470.00,
      method: "CARD",
      status: "Expired",
      date: "2025-01-15",
      receipt: true,
    },
    {
      order_id: "ORD-108",
      organization: "Career MentorZ",
      cards: 40,
      amount: 1960.00,
      method: "UPI",
      status: "Active",
      date: "2024-12-05",
      receipt: false,
    },
    // Add the rest of your sample data here...
  ];

  const dataToShow = transactions.length > 0 ? transactions : sampleTransactions;

  const filteredTransactions = dataToShow.filter(
    (t) =>
      t.order_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      t.organization?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      t.amount?.toString().includes(searchTerm)
  );

  const getStatusStyle = (status) => {
    if (status === "Active") {
      return "bg-green-950/60 text-gain-green border-green-800/50";
    }
    if (status === "Expired") {
      return "bg-red-950/60 text-loss-red border-red-800/50";
    }
    return "bg-gray-800 text-gray-400 border-gray-700";
  };

  // Handle Receipt Click
  const handleReceiptClick = (tx) => {
    if (!tx.receipt) return;
    setSelectedReceipt(tx);
  };

  const closeModal = () => {
    setSelectedReceipt(null);
  };

  const downloadReceipt = (tx) => {
    alert(`Downloading receipt for ${tx.order_id}... (Simulated)`);
    // In real app, you would generate PDF here
    console.log("Downloading receipt:", tx);
  };

  return (
    <div className="m-6 rounded-2xl shadow-2xl overflow-hidden border bg-card-bg border-card-border dark:bg-card-bg dark:border-card-border">
      {/* Header */}
      <div className="px-6 md:px-8 py-6 border-b flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 bg-secondary-bg border-card-border dark:bg-secondary-bg dark:border-card-border">
        <div>
          <h3 className="text-2xl font-bold text-primary-text">Payment Transactions</h3>
          <p className="mt-1 text-sm text-secondary-text">
            {filteredTransactions.length} transactions found
          </p>
        </div>

        <div className="flex items-center gap-4 w-full sm:w-auto">
          <div className="relative flex-1 sm:flex-none min-w-[240px]">
            <input
              type="text"
              placeholder="Search order, org, amount..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 rounded-xl bg-secondary-bg border border-card-border text-primary-text placeholder:text-secondary-text focus:border-accent-orange-500 focus:ring-2 focus:ring-accent-orange-500/20"
            />
            <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-secondary-text" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>

          <button
            onClick={fetchTransactions}
            disabled={loading}
            className="flex items-center gap-2 px-5 py-2.5 bg-accent-orange-900/30 hover:bg-accent-orange-900/50 text-accent-orange-400 hover:text-accent-orange-300 rounded-xl border border-accent-orange-800/50 transition-all disabled:opacity-50"
          >
            <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />
            Refresh
          </button>

          <button className="flex items-center gap-2 px-5 py-2.5 bg-accent-orange-600 hover:bg-accent-orange-700 text-white rounded-xl shadow-md transition-all">
            <Download className="w-4 h-4" />
            Export CSV
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[1100px]">
          <thead className="bg-secondary-bg border-b border-card-border dark:bg-secondary-bg dark:border-card-border">
            <tr>
              <th className="text-left py-4 px-8 font-semibold text-secondary-text">Order ID</th>
              <th className="text-left py-4 px-8 font-semibold text-secondary-text">Organization</th>
              <th className="text-left py-4 px-6 font-semibold text-secondary-text">Cards</th>
              <th className="text-left py-4 px-6 font-semibold text-secondary-text">Amount</th>
              <th className="text-left py-4 px-6 font-semibold text-secondary-text">Method</th>
              <th className="text-left py-4 px-6 font-semibold text-secondary-text">Status</th>
              <th className="text-left py-4 px-6 font-semibold text-secondary-text">Date</th>
              <th className="text-left py-4 px-6 font-semibold text-secondary-text">Receipt</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-card-border dark:divide-card-border">
            {loading ? (
              <tr><td colSpan={8} className="py-16 text-center text-secondary-text">Loading transactions...</td></tr>
            ) : filteredTransactions.length === 0 ? (
              <tr><td colSpan={8} className="py-16 text-center text-secondary-text">No transactions found</td></tr>
            ) : (
              filteredTransactions.map((tx) => (
                <tr key={tx.order_id} className="hover:bg-accent-orange-950/20 transition-colors dark:hover:bg-accent-orange-950/30">
                  <td className="py-5 px-8 font-medium text-primary-text">{tx.order_id}</td>
                  <td className="py-5 px-8 text-primary-text">{tx.organization}</td>
                  <td className="py-5 px-6 text-primary-text">{tx.cards}</td>
                  <td className="py-5 px-6 text-primary-text">₹{tx.amount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
                  <td className="py-5 px-6 text-primary-text">{tx.method}</td>
                  <td className="py-5 px-6">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium border ${getStatusStyle(tx.status)}`}>
                      {tx.status}
                    </span>
                  </td>
                  <td className="py-5 px-6 text-primary-text">{tx.date}</td>
                  <td className="py-5 px-6">
                    {tx.receipt ? (
                      <button 
                        onClick={() => handleReceiptClick(tx)}
                        className="text-accent-orange-400 hover:text-accent-orange-300 transition p-1"
                        title="View Receipt"
                      >
                        <FileText className="w-5 h-5" />
                      </button>
                    ) : (
                      <span className="text-secondary-text">N/A</span>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Receipt Modal */}
      {selectedReceipt && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50">
          <div className="bg-card-bg border border-card-border rounded-3xl w-full max-w-lg mx-4 overflow-hidden">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-card-border">
              <h2 className="text-xl font-semibold">Receipt #{selectedReceipt.order_id}</h2>
              <button onClick={closeModal} className="text-secondary-text hover:text-white">
                <X className="w-6 h-6" />
              </button>
            </div>

            {/* Receipt Content */}
            <div className="p-8 space-y-6">
              <div className="text-center">
                <div className="text-4xl mb-2">🧾</div>
                <p className="text-accent-orange-400 font-medium">Payment Receipt</p>
              </div>

              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <p className="text-secondary-text">Order ID</p>
                  <p className="font-medium">{selectedReceipt.order_id}</p>
                </div>
                <div>
                  <p className="text-secondary-text">Date</p>
                  <p className="font-medium">{selectedReceipt.date}</p>
                </div>
                <div>
                  <p className="text-secondary-text">Organization</p>
                  <p className="font-medium">{selectedReceipt.organization}</p>
                </div>
                <div>
                  <p className="text-secondary-text">Payment Method</p>
                  <p className="font-medium">{selectedReceipt.method}</p>
                </div>
              </div>

              <div className="border-t border-card-border pt-6">
                <div className="flex justify-between text-lg">
                  <span className="font-medium">Total Amount</span>
                  <span className="font-bold text-accent-orange-400">
                    ₹{selectedReceipt.amount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                  </span>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="p-6 border-t border-card-border flex gap-3">
              <button
                onClick={closeModal}
                className="flex-1 py-3 border border-card-border rounded-2xl font-medium hover:bg-secondary-bg"
              >
                Close
              </button>
              <button
                onClick={() => downloadReceipt(selectedReceipt)}
                className="flex-1 py-3 bg-accent-orange-600 hover:bg-accent-orange-700 text-white rounded-2xl font-medium flex items-center justify-center gap-2"
              >
                <Download className="w-4 h-4" />
                Download PDF
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}